module.exports = __webpack_public_path__ + "static/media/icon-character__miguel-de-unamuno-hover.3a0b3e5a.svg";